import styled from 'styled-components';

export const ArrowWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s all;
  ${({ rotate }) => rotate && `transform: rotate(${rotate}deg)`}
`;
